// External libraries
import styled from '@emotion/styled';

const DisclosuresContainer = styled.div`
  > * {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export { DisclosuresContainer };
